import type { ErrorEvent, EventHint } from "@sentry/react";

const http4xInterceptor = (exception: any): boolean => {
  if (!exception) return false;

  // fetch Response thrown directly
  if (exception instanceof Response) {
    return exception.status >= 400 && exception.status < 500;
  }

  // error with .status / .statusCode / .response.status (axios-style)
  const status =
    exception.status ?? exception.statusCode ?? exception.response?.status;

  return typeof status === "number" && status >= 400 && status < 500;
};

export const sentryBeforeSendInterceptor = (
  event: ErrorEvent,
  hint: EventHint,
): boolean => {
  if (http4xInterceptor(hint?.originalException)) return true;
  return false;
};
